/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Batch_ExportInputs */



/**
* | output |
* | --- |
* | "Batch Export" |
*
* @param {Shortcut_Keys_Name_Batch_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_batch_export = /** @type {((inputs?: Shortcut_Keys_Name_Batch_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Batch_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括エクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote")
	return /** @type {LocalizedString} */ ("Batch Export")
});